import { useState, useEffect, useRef } from 'react'
import { triangleBlueDown } from '../../../assets/images'

const RoundedSelect = ({ selectValues = [], selectOptions = [], curvalue = '', selectHandler = () => {}, classes = '', listClasses = 'w-52', disabled = false }) => {
  const [open, setOpen] = useState(false)
  const selectBoxRef = useRef('select-box-rounded-xs')
  const selectBoxIconRef = useRef('select-box-icon-rounded-xs')
  const selectValueRef = useRef('select-value-rounded-xs')

  const toggleSelect = () => setOpen(prevState => !prevState)

  const selectValueHandler = (event) => selectHandler(event.target.value)

  useEffect(() => {
    const handler = (event) => {
      if ([selectBoxRef.current, selectBoxIconRef.current, selectValueRef.current].includes(event.target)) return
      else setOpen(false)
    }
    document.body.addEventListener('click', handler)
    return () => document.body.removeEventListener('click', handler)
  }, [])

  return (
    <div 
      ref={selectBoxRef}
      className={`bg-white py-2.5 rounded-full border border-gray-200 inline-block flex gap-2 items-center justify-center cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} relative ${classes}`}
      style={{ paddingLeft: 14, paddingRight: 14 }}
      onClick={!disabled ? toggleSelect : undefined}
    >
      <h2 ref={selectValueRef} className='font-semibold text-sm text-gray-700 mb-0'>{curvalue}</h2>
      <img ref={selectBoxIconRef} src={triangleBlueDown} alt='dropdown-icon' className={open ? 'rotate-180 transform' : ''} />
      { open && !disabled &&
        <ul className={`absolute z-20 bg-white rounded py-3 top-12 right-0 ${listClasses} font-semibold shadow-md`}>
        { selectOptions.map((item, index) => {
          return <li key={selectValues[index]} value={selectValues[index]} onClick={selectValueHandler} className=' text-gray-600 text-sm font-semibold px-6 py-3 hover:bg-blue-100'>{item}</li>
        })}
        </ul>
      }
    </div>
  )
}

export default RoundedSelect